export default __webpack_public_path__ + "static/media/SourceSerifPro-Light.3dea7027.ttf";